<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{
        $t('homePage.homeworkStatus')
      }}</b>
    </div>
    <ts-loading-banner :loading="loading">
      <div
        class="widget-list widget-list-rounded m-b-10 inverse-mode"
        v-if="status.length > 0"
      >
        <a
          href="#"
          class="widget-list-item ts-whitespace-no-wrap"
          v-for="(s, index) in status"
          :key="index"
          @click.prevent="homework(s)"
        >
          <div class="widget-list-media icon">
            <i
              class="text-white"
              :class="[(bgName = randomBackground()), s.icon]"
            ></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">{{ s.status_name }}</h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-primary m-r-2" :class="bgName">{{
              getTotalByHomeworkStatus({
                homework_status_id: s.homework_status_id
              })
            }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
      </div>
      <div class="widget-list widget-list-rounded m-b-10" v-else>
        <a class="widget-list-item ts-whitespace-no-wrap">
          <div class="widget-list-content text-center">
            <h4 class="widget-list-title">
              {{ $t('homePage.noHomeworkStatus') }}
            </h4>
          </div>
        </a>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'status',
  data() {
    return {
      loading: false,
      status: [],
      backgrounds: [
        'bg-indigo',
        'bg-blue',
        'bg-purple',
        'bg-pink',
        'bg-red',
        'bg-orange',
        'bg-green',
        'bg-teal',
        'bg-primary',
        'bg-success',
        'bg-info',
        'bg-warning',
        'bg-danger'
      ]
    }
  },
  computed: {
    ...mapState('home/studentHomework', ['resources']),
    ...mapGetters('home/studentHomework', ['getTotalByHomeworkStatus'])
  },
  methods: {
    setData() {
      this.status = [
        {
          icon: 'fab fa-codiepie',
          homework_status_id: 1,
          status_name: 'Homework Progressing'
        },
        {
          icon: 'fas fa-times-circle',
          homework_status_id: 2,
          status_name: 'Homework Closed'
        }
      ]
      setInterval(() => {
        this.loading = false
      }, 900)
    },
    randomBackground() {
      return this.backgrounds[
        Math.floor(Math.random() * this.backgrounds.length)
      ]
    },
    homework(record) {
      this.$store.commit(
        'home/studentHomeworkLinkFromHome/SET_HOMEWORK_STATUS_ID',
        record.homework_status_id
      )
      this.$router.push({
        name: 'student-homework'
      })
    }
  },
  watch: {
    resources: debounce(function(value) {
      if (value) {
        this.loading = true
        this.status = []
        this.setData()
      }
    }, 500)
  }
}
</script>
